import axios from 'axios'
import { setCookie, getCookie } from '../../tools'
import { handleHttpErr } from '../apiHelper'
const state = {
    navHeight: 0,
    darkmode: getCookie('bszwmDarkmode') ? true : false,
    schulAdresse: undefined
}

const getters = {
    darkmode: state => state.darkmode,
    navHeight: state => state.navHeight,
    schulAdresse: state => state.schulAdresse
}

const actions = {
    setDarkmode({commit}, value){
        var cookie = {
            exdays: 500,
            name: "bszwmDarkmode",
            value
        }
        setCookie(cookie)
        value ? document.body.classList.add('bg-dark') : document.body.classList.remove('bg-dark')
        commit('setDarkmode', value)
    },
    setNavHeight({commit}, navHeight) { 
        commit('setNavHeight', navHeight)
    },
    async updateSchulAdresse({ commit }) {
        try {
            var res = await axios.get("main/schule")
            commit("updateSchulAdresse", res.data)
        }
        catch (err) {
            throw handleHttpErr(err)
        }
    }
}

const mutations = {
    setDarkmode: (state, darkmode) => state.darkmode = darkmode,
    setNavHeight: (state, navHeight) => state.navHeight = navHeight,
    updateSchulAdresse: (state, schulAdresse) => state.schulAdresse = schulAdresse,
}

export default {
    state,
    getters,
    actions,
    mutations
}